const state = {
  isActive: ""
};
const mutations = {
  toggleTab(state, name) {
    state.isActive = name;
  }
};
export default {
  namespaced: true,
  state,
  mutations
};
